import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { localized } from 'decorators'
import { Icon } from 'components/icons'
import { LoadingIndicator } from 'components/loading'
import { ErrorViewer } from 'components/error'
import { useStyles, useTheme } from './sideBar.css'
import logoImage from 'assets/images/logo.png'
import { SignInInfo } from './signInInfo'
import { redirectToLogout } from 'utils/redirectTo'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import Divider from '@material-ui/core/Divider'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { BackgroundActionsButton } from './backgroundActions'
import { FileAttachmentsButton } from './fileAttachments'

const CollapsibleItem = ({ item, localize, classes }) => {
  const [open, setOpen] = React.useState(false)
  const handleClick = React.useCallback(() => setOpen(!open), [open, setOpen])
  return (
    <React.Fragment>
      {/* <NavLink className={classes.a} activeClassName='active' to={item.path} exact={item.exact}> */}
      <ListItem button onClick={handleClick}>
        <ListItemIcon className={classes.item}>
          <Icon name={item.iconName} />
        </ListItemIcon>
        <ListItemText primary={localize(item.displayName)} className={classes.item}/>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      {/* </NavLink> */}
      <Collapse in={open} timeout='auto' unmountOnExit>
        <List component='div' disablePadding>
          {item.children.map((child, index) => <NavLink key={index} className={classes.a} activeClassName='active' to={child.path} exact={child.exact}>
            <ListItem button className={classes.nested}>
              <ListItemIcon className={classes.item}>
                <Icon name={child.iconName} />
              </ListItemIcon>
              <ListItemText primary={localize(child.displayName)} className={classes.item} />
            </ListItem>
          </NavLink>)}
        </List>
      </Collapse>
    </React.Fragment>
  )
}
const MenuLink = ({ item, localize, classes }) => {
  if (item.isSeparator) {
    return (
      <Divider className={classes.divider} />
    )
  }
  if (item.children && item.children.length > 0) {
    return (
      <CollapsibleItem item={item} localize={localize} classes={classes} />
    )
  }
  return (
    <NavLink className={classes.a} activeClassName='active' to={item.path} exact={item.exact}>
      <ListItem button>
        <ListItemIcon className={classes.item}>
          <Icon name={item.iconName} />
        </ListItemIcon>
        <ListItemText primary={localize(item.displayName)} className={classes.item} />
      </ListItem>
    </NavLink>
  )
}

const MenuContent = (props) => {
  const theme = useTheme()

  const handleOnErrorClick = () => {
    if (typeof props.reloadMenu === 'function') { props.reloadMenu() }
  }
  const { applicationMenu, classes } = props
  if (applicationMenu) {
    if (applicationMenu.fetching) { 
      return (<LoadingIndicator color={theme.palette.primary.main} outerStyle={{ marginTop: theme.spacing(3), marginLeft: theme.spacing(3)}} />)
    }
    if (applicationMenu.error) {
      return (<ErrorViewer onClick={handleOnErrorClick} />)
    }
    if (applicationMenu.entity && applicationMenu.entity.sideBarMenuItems) {
      return (
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          className={classes.listRoot}>
          {applicationMenu.entity.sideBarMenuItems.map((item, idx) => <MenuLink key={idx} item={item} localize={props.localize} classes={classes} />)}
        </List>
      )
    }
  }
  return null
}

export default localized((props) => {
  const { getMenu } = props
  const classes = useStyles()
  useEffect(() => {
    if (typeof getMenu === 'function') { getMenu() }
  }, [getMenu]);
  const handleLogout = React.useCallback(() => redirectToLogout(), [])
  return (
    <div className={classes.root} id='sidebar-wrapper'>
      <img alt='logo' className={classes.img} src={logoImage} />
      <BackgroundActionsButton />
      <FileAttachmentsButton />
      <SignInInfo localize={props.localize} oidc={props.oidc} logout={handleLogout} />
      <div className='sidebar-nav'>
        <MenuContent {...props} classes={classes} />
      </div>
    </div>
  )
})
